import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInputEyeBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 16,
	viewBox: "0 0 22 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.5261 7.66607C18.8871 4.16081 15.16 1 10.8 1C5.8942 1 2.36808 4.89841 1.07393 7.66607C0.975356 7.87726 0.975356 8.12235 1.07393 8.33354C2.71291 11.8392 6.44001 15 10.8 15C15.7058 15 19.2319 11.1016 20.5261 8.33393C20.6246 8.12235 20.6246 7.87726 20.5261 7.66607Z",
		stroke: "black",
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.7988 10.625C12.2486 10.625 13.4238 9.44975 13.4238 8C13.4238 6.55025 12.2486 5.375 10.7988 5.375C9.34908 5.375 8.17383 6.55025 8.17383 8C8.17383 9.44975 9.34908 10.625 10.7988 10.625Z",
		stroke: "black",
		strokeMiterlimit: 10
	})]
});
export default SvgInputEyeBlack;
